import React, { useRef, useEffect } from 'react';

interface AdTagProps {
  adHTML: string;
}

const AdTag: React.FC<AdTagProps> = ({ adHTML }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // コンテナ内の script タグを抽出し、再生成する
    if (containerRef.current) {
      const scripts = containerRef.current.getElementsByTagName('script');
      // HTMLCollection を Array に変換してループ
      Array.from(scripts).forEach((script) => {
        const newScript = document.createElement('script');
        newScript.type = script.type || 'text/javascript';

        // src 属性がある場合は新たに script タグを作成してロード
        if (script.src) {
          newScript.src = script.src;
          newScript.async = script.async;
        } else {
          // インラインスクリプトの場合は、テキストをそのまま設定
          newScript.text = script.innerHTML;
        }
        // script タグを置き換えることで実行させる
        script.parentNode?.replaceChild(newScript, script);
      });
    }
  }, [adHTML]);

  if (!adHTML.trim()) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className="ad-container"
      dangerouslySetInnerHTML={{ __html: adHTML }}
    />
  );
};

export default AdTag;
